export default __webpack_public_path__ + "img/color-picker-xl.22a68592.png";